/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";

export const BusinessNameFormatter = (cellContent, row, rowIndex) => {
  const { business_name } = row;
  return (
    <>
      <div className="d-flex align-items-center text-capitalize">
        {business_name ? business_name : "-"}
      </div>
      <> </>
    </>
  );
};
